module.exports = __webpack_public_path__ + "media/images/srfLogo-ccde53c856ef8c4e373a9a7fa92883e8.png";